<script>
import GeneralProductStatementSelect from "@core/components/product/GeneralProductStatementSelect.vue";
import { BModal } from 'bootstrap-vue'

export default {
    components: {GeneralProductStatementSelect, BModal},
    data() {
        return {
            value: null
        }
    },
    methods: {
        show() {
            this.$refs['selector'].show();
        },
        valueSelected(value) {
            this.value = value;
            // this.$emit('input', value);
        },
        closeAndEmit() {
            this.$emit('input', this.value);
            this.value = null;
            this.$refs.selector.hide();
        }
    }
}
</script>

<template>
    <b-modal
        ref="selector"
        cancel-variant="outline-secondary"
        size="lg"
        centered
        no-close-on-backdrop
        title="Select statement"
        @ok="closeAndEmit"
        @hide="$emit('modalHide')"
    >
        <GeneralProductStatementSelect
            @input="valueSelected"
        />
    </b-modal>
</template>
